import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import WarrantyDashboard from "./WarrantyDashboard";

const EfficiencyDB = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (location.key === undefined || location.key === null || location.key === 'default') {
      navigate("/");
    }
  }, [location, navigate]);

  return <WarrantyDashboard />;
};

export default EfficiencyDB;
